<template>
  <div class="search-box" :class="{ expanded: expanded }">
    <Input
      :placeholder="placeholder"
      :value="value"
      class="search-input"
      :class="{ mobile: isMobile, desktop: !isMobile }"
      @input="$emit('input', $event.target.value)"
    />
    <i v-if="!expanded" class="material-icons" @click="onSearchClick">search</i>
    <i v-else class="material-icons" @click="onSearchClick">close</i>
  </div>
</template>

<script>
export default {
  name: "search-bar",
  props: {
    placeholder: String,
    value: String,
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expanded: false
    };
  },
  methods: {
    onSearchClick() {
      this.expanded = !this.expanded;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";

.search-input {
  width: 0;
  background-color: $brand-gray-light;
  transition: all 0.3s ease-in-out;
  padding: 0;
}

.search-box {
  position: absolute;
  right: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: all 0.3s ease-in-out;
  padding: 0.5rem 0.75rem;
  margin-right: -0.75rem;

  &.expanded {
    background-color: $brand-gray-light;

    border-radius: 5rem;

    .search-input {
      width: 9rem;
    }
  }
}

input {
  outline: none;
  border: none;
  height: 100%;
  color: $gyra-grey-dark;
}
</style>
